module.exports = __webpack_public_path__ + "assets/img/IMG033.814473e8.png";